import { render, staticRenderFns } from "./newClass.vue?vue&type=template&id=2ba78356&scoped=true&"
import script from "./newClass.vue?vue&type=script&lang=js&"
export * from "./newClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba78356",
  null
  
)

export default component.exports